var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lx-check",on:{"click":_vm.doCheck}},[_c('div',{staticClass:"check_icon_wrap"},[(_vm.isCheck)?_c('span',{staticClass:"icon pre lx-pointer"}):_c('span',{staticClass:"icon nor lx-pointer"})]),_vm._t("text")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }